export const defaultFontFamily = () => {
  return `'Nunito', 'Helvetica Neue', Helvetica, Arial, sans-serif`;
};
